import { useState } from 'react';
import { ThemeProvider } from '@/hooks/useTheme';
import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import BrandStatement from '@/pages/home/components/BrandStatement';
import CoreServicesSection from '@/pages/home/components/CoreServicesSection';
import IndustriesSection from '@/pages/home/components/IndustriesSection';
import ProcessSection from '@/pages/home/components/ProcessSection';
import ResultsSection from '@/pages/home/components/ResultsSection';
import CTASection from '@/pages/home/components/CTASection';
import FooterSection from '@/pages/home/components/FooterSection';
import AuditModal from '@/pages/home/components/AuditModal';

function HomeContent() {
  const [auditOpen, setAuditOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans transition-colors duration-500">
      <Navbar onBookAudit={() => setAuditOpen(true)} />
      <main>
        <HeroSection onBookAudit={() => setAuditOpen(true)} />
        <BrandStatement />
        <CoreServicesSection />
        <IndustriesSection />
        <ProcessSection />
        <ResultsSection />
        <CTASection onBookAudit={() => setAuditOpen(true)} />
      </main>
      <FooterSection />
      <AuditModal isOpen={auditOpen} onClose={() => setAuditOpen(false)} />
    </div>
  );
}

export default function Home() {
  return (
    <ThemeProvider>
      <HomeContent />
    </ThemeProvider>
  );
}